export const FaqValidationSchema = {
    titleFaq: [
        { rule: "required", message: "title is required" }
    ],
    descriptionFaq: [
        { rule: "required", message: "description is required" },
    ],
}